import React from 'react';
import fp from '../../../../utils/fp';
import { getMatchOption } from '../../../shared/selectFn';
import { Layer, Dimension, Indicator } from '../../constants/dimension';

function DimensionBar(props) {
    const { business: propsBusiness, params, onExpand, onChange } = props;

    const handleClick = (e, key) => {
        const { statisticalRange, lineOfBusiness, moduleType, analysisDimension } = params;
        const value = e.target.getAttribute('data-type');
        switch (key) {
            case 'statisticalRange': {
                const { layer } = getMatchOption(Indicator, 'moduleType', moduleType);
                const dimension = layer[value].dimension;
                if (!dimension[analysisDimension]) {
                    params.analysisDimension = Object.keys(dimension)[0];
                }
                params.statisticalRange = value;
                break;
            }
            case 'moduleType': {
                const { layer, business } = getMatchOption(Indicator, 'moduleType', value);
                if ( layer && !layer[statisticalRange]) {
                    params.statisticalRange = Object.keys(layer)[0];
                }
                const { typeValue } = getMatchOption(propsBusiness, 'typeConfigureId', lineOfBusiness);
                if (!business.includes(typeValue)) {
                    params.lineOfBusiness = propsBusiness[0].typeConfigureId;
                }
                const dimension = layer? layer[params.statisticalRange].dimension : getMatchOption(Indicator, 'moduleType', value).dimension;
                if (!dimension[analysisDimension]) {
                    params.analysisDimension = Object.keys(dimension)[0];
                }
                params.moduleType = value;
                break;
            }
            default:
                params[key] = value;
                break;
        }
        onChange(params);
    }

    const { statisticalRange, moduleType, lineOfBusiness, analysisDimension } = params;
    const allBusiness = fp.contains(moduleType, ['EmpOutPutRate', 'MONTH_PER_STANDARD_VISIT_AMOUNT', 'MONTH_PER_VISIT_AMOUNT', 'MONTH_PER_RANDOM_AMOUNT'])// 业务线只能选择 “所有项目”的moduleType
    let { layer, business, dimension = {} } = getMatchOption(Indicator, 'moduleType', moduleType);
    dimension = layer ? (layer || {})[statisticalRange].dimension : dimension;
    let authArry=[];
    const {financeIndicatorAnalysis, projectIndicatorAnalysis, personIndicatorAnalysis} = props;
    if(financeIndicatorAnalysis){
        authArry.push("finance");
    }
    if(projectIndicatorAnalysis){
        authArry.push("project");
    }
    if(personIndicatorAnalysis) {
        authArry.push("person");
    }
    return (
        <div className="dsFilter">
            <dl className="dsFilterList">
                <dt className="dsFilterLabel">分析层面:</dt>
                <dd className="dsFilterItemWrap" >
                    {
                        layer?
                        Object.keys(Layer)
                            .filter(i => (layer || {})[i])
                            .map(i =>
                                <a
                                    key={i}
                                    data-type={i}
                                    className={`dsFilterItem${statisticalRange == i ? ' active' : ''}`}
                                    onClick={e => handleClick(e, 'statisticalRange')}
                                >
                                    {Layer[i]}
                                </a>
                            ):
                            <span>-</span>
                    }
                </dd>
            </dl>
            <dl className="dsFilterList">
                <dt className="dsFilterLabel">业务线:</dt>
                <dd className="dsFilterItemWrap" >
                    {
                        propsBusiness
                            .filter(i => (business || []).includes(i.typeValue))
                            .map(i =>
                                {
                                    if((allBusiness && i.typeConfigureId == '-1') || !allBusiness){
                                        return <a
                                        key={i.typeConfigureId}
                                        data-type={i.typeConfigureId}
                                        className={`dsFilterItem${lineOfBusiness == i.typeConfigureId ? ' active' : ''}`}
                                        onClick={e => handleClick(e, 'lineOfBusiness')}
                                    >
                                        {i.typeValue}
                                    </a>
                                    }
                                }
                            )
                    }
                </dd>
            </dl>
            <dl className="dsFilterList">
                <dt className="dsFilterLabel">分析指标:</dt>
                <dd className="dsFilterItemWrap" >
                    {
                        Indicator
                        .filter(i => (authArry|| []).includes(i.source))
                        .map(i =>
                            {
                                if(lineOfBusiness == '-1' || !i.allBusiness ) {
                                    return <a
                                        key={i.moduleType}
                                        data-type={i.moduleType}
                                        className={`dsFilterItem${moduleType == i.moduleType ? ' active' : ''}`}
                                        onClick={e => handleClick(e, 'moduleType')}
                                    >
                                        {i.name}
                                    </a>
                                }
                            }
                            
                        )
                    }
                </dd>
            </dl>
            <dl className="dsFilterList noBorder">
                <dt className="dsFilterLabel">分析维度:</dt>
                <dd className="dsFilterItemWrap" >
                    {
                        Object.keys(Dimension)
                            .filter(i => (dimension || {})[i])
                            .map(i =>
                                <a
                                    key={i}
                                    data-type={i}
                                    className={`dsFilterItem${analysisDimension == i ? ' active' : ''}`}
                                    onClick={e => handleClick(e, 'analysisDimension')}
                                >
                                    {Dimension[i]}
                                </a>
                            )
                    }
                </dd>
            </dl>
            <i onClick={() => onExpand('')} style={{ fontSize: '20px' }} className="icon iconfont">&#xe628;</i>
        </div>
    );
}

export default DimensionBar;


// WEBPACK FOOTER //
// ./src/components/homePage/DimensionAnalysis/components/DimensionBar.js